export enum InternshipEducationLevelEnum {
  BacPro = 'bacpro',
  BepCap = 'bep_cap',
  Bac = 'bac',
  BacPlus2 = 'bac2',
  BacPlus3 = 'bac3',
  BacPlus5 = 'bac5',
  BacPlus8 = 'bac8',
}

export const DisplayInternshipEducationLevel: Record<InternshipEducationLevelEnum, string> = {
  [InternshipEducationLevelEnum.BacPro]: 'Bac professionnel',
  [InternshipEducationLevelEnum.BepCap]: 'BEP / CAP',
  [InternshipEducationLevelEnum.Bac]: 'Bac',
  [InternshipEducationLevelEnum.BacPlus2]: 'Bac + 2',
  [InternshipEducationLevelEnum.BacPlus3]: 'Bac + 3',
  [InternshipEducationLevelEnum.BacPlus5]: 'Bac + 5',
  [InternshipEducationLevelEnum.BacPlus8]: 'Bac + 8',
};
